import Header from '@/pages/home/components/Header';
import Hero from '@/pages/home/components/Hero';
import Features from '@/pages/home/components/Features';
import About from '@/pages/home/components/About';
import Contact from '@/pages/home/components/Contact';
import IndexSection from '@/pages/home/components/IndexSection';
import CarouselSection from '@/pages/home/components/CarouselSection';
import CardsSection from '@/pages/home/components/CardsSection';
import Comments from '@/pages/home/components/Comments';
import AppDownload from '@/pages/home/components/AppDownload';
import Faq from '@/pages/home/components/Faq';
import Ranking from '@/pages/home/components/Ranking';
import Media from '@/pages/home/components/Media';
import Topics from '@/pages/home/components/Topics';
import Updates from '@/pages/home/components/Updates';
import Footer from '@/pages/home/components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <Hero />
        <Features />
        <About />
        <Contact />
        <IndexSection />
        <CarouselSection />
        <CardsSection />
        <Comments />
        <AppDownload />
        <Faq />
        <Ranking />
        <Media />
        <Topics />
        <Updates />
      </main>
      <Footer />
    </div>
  );
}